import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import routes from "components/routes";
import { RadioWrapper, RadioListWrapper } from "./styles";
import SmallCard from "./SmallCard";

const InsuranceCard = ({ list, selectedIndices, onChange }) => {
  const navigate = useNavigate()
  const [selectedCards, setSelectedCards] = useState(new Set()); // using set data type to handle duplicacy

  useEffect(() => {
    // adding 
    if(selectedIndices && selectedIndices.length) {
      selectedIndices.forEach(element => addToSelected(element))
    }
  }, []);

  useEffect(() => {
    onChange(selectedCards);
  }, [selectedCards]);

  const isSelected = (index) => {
    return selectedCards.has(index);
  };

  const addToSelected = (index, text) => {
    if (isSelected(index)) {
      deleteFromSelectedCards(setSelectedCards, index);
    } else {
      if (selectedCards.size > 0) return
      localStorage.setItem('mark_index', text)
      addToSelectedCards(setSelectedCards, index);
      navigate(`/${routes.UPLOAD_DOCUMENT}/onboarding`)
    }
  };

  const addToSelectedCards = (setSelectedCards, index) => {
    setSelectedCards((prev) => new Set(prev).add(index));
  };

  const deleteFromSelectedCards = (setSelectedCards, index) => {
    setSelectedCards((prev) => {
      const newSet = new Set(prev);
      newSet.delete(index);
      return newSet;
    });
  };

  return (
    <RadioListWrapper>
      {list.map((text, index) => (
        <RadioWrapper key={index}>
          <SmallCard
            text={text}
            isSelected={isSelected(index)}
            onSelect={() => addToSelected(index, text)}
          />
        </RadioWrapper>
      ))}
    </RadioListWrapper>
  );
};

export default InsuranceCard;
